import fetch ,{postFrom} from "../utils/fetch";

// 报修列表
export function getList(data) {
  return fetch({
    method:'POST',
    url:'repair/list',
    data
  })
}

// 查询条件
export function getCondition(params) {
  return fetch({
    method:'GET',
    url:'repair/listRepairCondition',
    params
  })
}

// 维修下单接口
export function order(data) {
  return fetch({
    method:'POST',
    url:'repair/order',
    data
  })
}

// 取消报修下单接口
export function cancelRepairOrder(params) {
  return fetch({
    method:'GET',
    url:'repair/cancelRepairOrder',
    params
  })
}

// 维修详情
export function getOrderDetail(order_sn) {
  return fetch({
    method:'GET',
    url:'repair/repairOrderDetail',
    params:{
      order_sn
    }
  })
}

// 获取故障标签
export function getFailureTags(params) {
  return fetch({
    method:'GET',
    url:'repair/listMalfunctionTags',
    params
  })
}

// 获取预约时间
export function getAppointmentTime(params) {
  return fetch({
    method:'GET',
    url:'repair/listAppointmentTime',
    params
  })
}

// 取消原因下拉框
export function getCancelReasonList() {
  return fetch({
    method:'GET',
    url:'repair/getCancelReasonList'
  })
}
